<template>
  <div class="foot">
    <div class="all_box">
      <div class="foot_box">
        <div class="foot_nav">
          <div class="foot_nav_list">
            <div class="foot_nav_item one_item">关于我们</div>
            <div class="foot_nav_item" @click="routerLink('about')">睿兔跑腿介绍</div>
            <div class="foot_nav_item" @click="routerLink('contact')">联系睿兔跑腿</div>
          </div>
          <div class="foot_nav_list">
            <div class="foot_nav_item one_item">网站导航</div>
            <div class="foot_nav_item" @click="routerLink('placeOrder')">在线下单</div>
            <div class="foot_nav_item" @click="routerLink('join')">一键加盟</div>
            <div class="foot_nav_item" @click="routerLink('joinRuitu')">加入睿兔</div>
          </div>
          <div class="foot_nav_list">
            <div class="foot_nav_item one_item">联系我们</div>
            <div class="foot_nav_item">service@richtoo.cn</div>
            <div class="foot_nav_item two_item">400-891-6060</div>
          </div>
        </div>
        <div class="foot_pic">
          <div class="foot_pic_top">
            <div class="foot_pic_erweima">
              <img src="../assets/gzh.png" style="width:135px" alt="" />
              <p>微信公众号</p>
            </div>
            <div class="foot_pic_erweima">
              <img src="../assets/xcx.png" style="width:135px" alt="" />
              <p>微信小程序</p>
            </div>
          </div>
          <div class="foot_pic_bottom">
            <img src="../assets/foot_logo.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="icp">
      备案号：苏ICP备2024106450号-1  
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {

      }
    },
    methods: {
      routerLink(name) {
        if (name == this.$route.name) {
          return
        }
        this.$router.push({
          name: name,
        });
        window.scrollTo(0, 0);
      },
    }
  }
</script>
<style lang="scss" scoped>
  img {
    display: block;
  }

  .all_box {
    width: 1380px;
    margin: 0 auto;
    position: relative;
  }

  .foot {
    padding: 60px 0 40px;
    background: #1a1a1a;

    .foot_box {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      .foot_nav {
        width: 50%;
        text-align: left;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        .foot_nav_list {
          color: #969696;
          font-size: 16px;

          .foot_nav_item:first-child {
            margin-top: 0;
          }

          .foot_nav_item:last-child {
            margin-bottom: 0;
          }

          .foot_nav_item {
            margin: 50px 0;
            cursor: pointer;
          }

          .one_item {
            font-size: 18px;
          }

          .two_item {
            font-size: 24px;
            font-weight: bold;
          }
        }
      }

      .foot_pic {
        .foot_pic_top {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;

          .foot_pic_erweima {
            img {}

            p {
              margin: 0;
              font-size: 18px;
              color: #969696;
            }
          }
        }

        .foot_pic_bottom {
          margin-top: 28px;
        }
      }
    }
  }
  .icp{
    color: #666;
  }
</style>